
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.5 12.0707C24.5 5.40424 19.1274 0 12.5 0C5.87258 0 0.5 5.40424 0.5 12.0707C0.5 18.0956 4.88823 23.0893 10.625 23.9948V15.5599H7.57812V12.0707H10.625V9.41139C10.625 6.38617 12.4165 4.71513 15.1576 4.71513C16.4705 4.71513 17.8438 4.95088 17.8438 4.95088V7.92141H16.3306C14.8399 7.92141 14.375 8.85187 14.375 9.80645V12.0707H17.7031L17.1711 15.5599H14.375V23.9948C20.1118 23.0893 24.5 18.0956 24.5 12.0707Z","fill":"#1877F2"}})])
          )
        }
      }
    